import img1Fall from '../assets/images/teamFront/kevin-min.png';
import img2Fall from '../assets/images/teamFront/david-min.png';
import img3Fall from '../assets/images/teamFront/august-blk.jpeg';
import img4Fall from '../assets/images/teamFront/alvar-blk.jpeg';
import img5Fall from '../assets/images/teamFront/patrik-blk.jpeg';
import img6Fall from '../assets/images/teamFront/ali-front.jpg';
import img7Fall from '../assets/images/teamFront/michael-min.png';
import img8Fall from '../assets/images/teamFront/ebba-blk.jpeg';
import img9Fall from '../assets/images/teamFront/bruno-blk.jpeg';

import bgimg1Fall from '../assets/images/teamBgClose/kevin-close-min.jpg';
import bgimg2Fall from '../assets/images/teamBgClose/david-close-min.jpg';
import bgimg3Fall from '../assets/images/teamBgClose/august-close-min.jpg';
import bgimg4Fall from '../assets/images/teamBgClose/alvar-close-min.jpg';
import bgimg5Fall from '../assets/images/teamBgClose/patrik-close-min.jpg';
import bgimg6Fall from '../assets/images/teamBgClose/ali-close.jpg';
import bgimg7Fall from '../assets/images/teamBgClose/michael-close-min.jpg';
import bgimg8Fall from '../assets/images/teamBgClose/ebba-close-min.jpg';
import bgimg9Fall from '../assets/images/teamBgClose/bruno-close-min.jpg';

export default [
  {
    source: { fall: img7Fall },
    bgSource: { fall: bgimg7Fall },
    name: 'Michael Dragomir',
    role: 'CEO / developer',
    mail: 'michael@weapp.se',
    phone: '+4670-990 79 26',
    desc:
      'CEO and senior developer who early on decided that We App would be a different company with a strong focus on startups and game-changing technology. Always bringing expertise and knowledge to the table for all projects.',
  },
  {
    source: { fall: img1Fall },
    bgSource: { fall: bgimg1Fall },
    name: 'Kevin Hedberg Griffith',
    role: 'Head of Software Development',
    mail: 'kevin@weapp.se',
    phone: '+4670-455 75 66',
    desc:
      "Head of software development who've led value creating projects in a number of different industries. Whether in medtech, automation journeys or new media experience projects he guides the team with a steady hand.",
  },
  {
    source: { fall: img2Fall },
    bgSource: { fall: bgimg2Fall },
    name: 'David Göthensten',
    role: 'Head of Business Development',
    mail: 'david@weapp.se',
    phone: '‭+4673-531 93 32‬',
    desc:
      "Our Head of business development who broadens We App's network of friends, with a special focus on partnerships within the startup eco-system.",
  },
  {
    source: { fall: img8Fall },
    bgSource: { fall: bgimg8Fall },
    name: 'Ebba Skretting',
    role: 'Lead UX-designer',
    mail: 'ebba@weapp.se',
    // phone: '‭+46 72-166 78 23',
    desc:
      "Our talented lead UX-designer who would never allow us to create a product that doesn't keep the customer at heart.",
  },
  {
    source: { fall: img6Fall },
    bgSource: { fall: bgimg6Fall },
    name: 'Ali Baker',
    role: 'Mobile developer',
    mail: 'ali@weapp.se',
    // phone: '‭+46 72-288 08 32‬',
    desc:
      'Mobile developer with a keen eye for design as well as robust and efficient code. Comes with experience from the interesting Gamification space.',
  },
  {
    source: { fall: img9Fall },
    bgSource: { fall: bgimg9Fall },
    name: 'Bruno Teglas',
    role: 'Social Media Manager',
    mail: 'bruno@weapp.se',
    // phone: '‭+46 72-166 78 23',
    desc:
      'Our warm-hearted community leader, who works both with upholding our strong internal culture, as well as communicating this and all our awesome projects to a wider audience.',
  },
  {
    source: { fall: img3Fall },
    bgSource: { fall: bgimg3Fall },
    name: 'August Posner',
    role: 'Fullstack developer',
    mail: 'august@weapp.se',
    // phone: '‭+4672-322 72 50‬',
    desc:
      'Fullstack developer with a background in theoretical mathematics whose new passions lies in building powerful algorithms.',
  },
  {
    source: { fall: img5Fall },
    bgSource: { fall: bgimg5Fall },
    name: 'Patrik Rikama-Hinnenberg',
    role: 'Frontend developer',
    mail: 'patrik@weapp.se',
    // phone: '+4670-000 00 00',
    desc:
      'Frontend developer who is working at the forefront of web & mobile apps and technologies. Often focusing on digitalization journeys.',
  },
  {
    source: { fall: img4Fall },
    bgSource: { fall: bgimg4Fall },
    name: 'Alvar Aronija',
    role: 'Fullstack developer',
    mail: 'alvar@weapp.se',
    // phone: '‭+46 72-166 78 23',
    desc:
      'Fullstack developer equally comfortable with all native platforms as well as new media experiences, e.g. Augmented Reality.',
  },
];
